<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="pt1"><a href="#/xhtml/contents#c_pt1">Rochelle Alers</a></p>
<p class="pt"><a href="#/xhtml/contents#c_pt1">love lessons</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?05c0fc6a